/**
 * Pełna lista ras psów i kotów na podstawie nomenklatury FCI.
 * Źródło: https://www.fci.be/en/nomenclature/
 * Używana w: DogWizardNew, KennelWizard, LitterWizard, ProfilePanel (backend)
 */

// ─── RASY PSÓW (FCI + popularne mieszanki) ───
export const DOG_BREEDS = [
  // I Grupa FCI — Owczarki i psy pasterskie
  'Owczarek Niemiecki Krótkowłosy',
  'Owczarek Niemiecki Długowłosy',
  'Owczarek Belgijski Malinois',
  'Owczarek Belgijski Tervueren',
  'Owczarek Belgijski Groenendael',
  'Owczarek Belgijski Laekenois',
  'Border Collie',
  'Australian Shepherd',
  'Australian Cattle Dog',
  'Australian Kelpie',
  'Owczarek Szkocki Długowłosy (Collie Rough)',
  'Owczarek Szkocki Krótkowłosy (Collie Smooth)',
  'Owczarek Szetlandzki (Sheltie)',
  'Owczarek Staroangielski (Bobtail)',
  'Bearded Collie',
  'Biały Owczarek Szwajcarski',
  'Owczarek Podhalański',
  'Polski Owczarek Nizinny (PON)',
  'Owczarek Kaukaski',
  'Owczarek Środkowoazjatycki',
  'Owczarek Południoworosyjski',
  'Owczarek Holenderski',
  'Owczarek Chorwacki',
  'Owczarek z Majorki',
  'Owczarek Bergamasco',
  'Owczarek Maremmano-Abruzzese',
  'Owczarek Pirenejski (Berger des Pyrénées)',
  'Briard (Berger de Brie)',
  'Beauceron (Berger de Beauce)',
  'Owczarek Pikardyjski',
  'Pumi',
  'Puli',
  'Mudi',
  'Komondor',
  'Kuvasz',
  'Czuwacz Słowacki',
  'Wilczak Czechosłowacki',
  'Saarloos Wolfhond',
  'Schipperke',
  'Welsh Corgi Pembroke',
  'Welsh Corgi Cardigan',
  'Bouvier des Flandres',
  'Bouvier des Ardennes',
  'Owczarek Islandzki',
  'Lapphund Fiński',
  'Buhund Norweski',
  'Vallhund Szwedzki',
  'Pies Kanaanejski',
  'Lancashire Heeler',
  'Hovawart',

  // II Grupa FCI — Pinczery, Sznaucery, Molosy, Psy górskie
  'Doberman',
  'Pinczer Miniaturowy',
  'Pinczer Austriacki',
  'Affenpinscher',
  'Sznaucer Olbrzymi',
  'Sznaucer Średni',
  'Sznaucer Miniaturowy',
  'Czarny Terier Rosyjski',
  'Bokser',
  'Rottweiler',
  'Dog Niemiecki',
  'Cane Corso',
  'Mastif Angielski (Mastiff)',
  'Bullmastiff',
  'Mastif Tybetański',
  'Mastif Hiszpański',
  'Mastif Pirenejski',
  'Mastino Napoletano',
  'Dogue de Bordeaux',
  'Dogo Argentino',
  'Dogo Canario',
  'Fila Brasileiro',
  'Tosa Inu',
  'Shar Pei',
  'Bulldog Angielski',
  'Broholmer',
  'Leonberger',
  'Nowofundland (Newfoundland)',
  'Landseer',
  'Bernardyn (Saint Bernard)',
  'Berneński Pies Pasterski',
  'Duży Szwajcarski Pies Pasterski',
  'Appenzeller Sennenhund',
  'Entlebucher Sennenhund',
  'Kangal (Pies Pasterski Anatolijski)',

  // III Grupa FCI — Teriery
  'Airedale Terrier',
  'American Staffordshire Terrier',
  'Staffordshire Bull Terrier',
  'Bull Terrier',
  'Miniaturowy Bull Terrier',
  'Jack Russell Terrier',
  'Parson Russell Terrier',
  'Fox Terrier Gładkowłosy',
  'Fox Terrier Szorstkowłosy',
  'Yorkshire Terrier',
  'West Highland White Terrier',
  'Scottish Terrier',
  'Cairn Terrier',
  'Border Terrier',
  'Norwich Terrier',
  'Norfolk Terrier',
  'Kerry Blue Terrier',
  'Irish Terrier',
  'Soft Coated Wheaten Terrier',
  'Bedlington Terrier',
  'Welsh Terrier',
  'Lakeland Terrier',
  'Manchester Terrier',
  'Dandie Dinmont Terrier',
  'Skye Terrier',
  'Sealyham Terrier',
  'Silky Terrier Australijski',
  'Terier Australijski',
  'Boston Terrier',

  // IV Grupa FCI — Jamniki
  'Jamnik Standardowy Krótkowłosy',
  'Jamnik Standardowy Długowłosy',
  'Jamnik Standardowy Szorstkowłosy',
  'Jamnik Miniaturowy Krótkowłosy',
  'Jamnik Miniaturowy Długowłosy',
  'Jamnik Miniaturowy Szorstkowłosy',
  'Jamnik Króliczy Krótkowłosy',
  'Jamnik Króliczy Długowłosy',
  'Jamnik Króliczy Szorstkowłosy',

  // V Grupa FCI — Szpice i typy pierwotne
  'Husky Syberyjski',
  'Alaskan Malamute',
  'Samoyed',
  'Akita Inu',
  'Akita Amerykańska',
  'Shiba Inu',
  'Hokkaido',
  'Kai',
  'Kishu',
  'Shikoku',
  'Chow Chow',
  'Eurasier',
  'Pomeranian (Szpic Miniaturowy)',
  'Szpic Niemiecki Mały',
  'Szpic Niemiecki Średni',
  'Szpic Niemiecki Duży',
  'Szpic Niemiecki Wilczy (Keeshond)',
  'Szpic Fiński',
  'Szpic Japoński',
  'Volpino Italiano',
  'Norrbottenspets',
  'Basenji',
  'Pharaoh Hound (Pies Faraona)',
  'Cirneco dell\'Etna',
  'Podenco Ibicenco',
  'Podenco Canario',
  'Perro sin Pelo del Perú',
  'Xoloitzcuintle',
  'Thai Ridgeback',
  'Jämthund',
  'Norsk Elghund Szary',
  'Norsk Elghund Czarny',
  'Karelski Pies na Niedźwiedzie',
  'Łajka Zachodniosyberyjska',
  'Łajka Wschodniosyberyjska',
  'Łajka Rosyjsko-Europejska',

  // VI Grupa FCI — Gończe i posokowce
  'Beagle',
  'Basset Hound',
  'Basset Artésien Normand',
  'Basset Fauve de Bretagne',
  'Bloodhound',
  'Rhodesian Ridgeback',
  'Dalmatyńczyk',
  'Gończy Polski',
  'Ogar Polski',
  'Harrier',
  'Foxhound Angielski',
  'Foxhound Amerykański',
  'Grand Basset Griffon Vendéen',
  'Petit Basset Griffon Vendéen',
  'Posokowiec Bawarski',
  'Posokowiec Hanowerski',
  'Beagle-Harrier',
  'Billy',
  'Hamiltonsstövare',

  // VII Grupa FCI — Wyżły
  'Wyżeł Węgierski Krótkowłosy (Vizsla)',
  'Wyżeł Węgierski Szorstkowłosy',
  'Wyżeł Niemiecki Krótkowłosy (Deutsch Kurzhaar)',
  'Wyżeł Niemiecki Szorstkowłosy (Deutsch Drahthaar)',
  'Wyżeł Niemiecki Długowłosy (Deutsch Langhaar)',
  'Pointer Angielski',
  'Seter Irlandzki Czerwony',
  'Seter Irlandzki Czerwono-Biały',
  'Seter Angielski',
  'Seter Gordon',
  'Weimaraner',
  'Weimaraner Długowłosy',
  'Bracco Italiano',
  'Spinone Italiano',
  'Épagneul Breton',
  'Épagneul Français',
  'Münsterländer Mały',
  'Münsterländer Duży',
  'Griffon Korthals',
  'Stabyhoun',
  'Drentsche Patrijshond',
  'Braque Français',
  'Braque d\'Auvergne',
  'Braque Saint-Germain',
  'Pudelpointer',
  'Cesky Fousek',
  'Perdiguero de Burgos',
  'Slovenský Hrubosrstý Stavač',

  // VIII Grupa FCI — Retrievery, Aportery, Psy wodne
  'Labrador Retriever',
  'Golden Retriever',
  'Flat Coated Retriever',
  'Curly Coated Retriever',
  'Chesapeake Bay Retriever',
  'Nova Scotia Duck Tolling Retriever',
  'Cocker Spaniel Angielski',
  'Cocker Spaniel Amerykański',
  'Springer Spaniel Angielski',
  'Springer Spaniel Walijski',
  'Clumber Spaniel',
  'Sussex Spaniel',
  'Field Spaniel',
  'Irish Water Spaniel',
  'Barbet',
  'Lagotto Romagnolo',
  'Portugalski Pies Wodny',
  'Hiszpański Pies Wodny',
  'Fryzyjski Pies Wodny (Wetterhoun)',
  'American Water Spaniel',

  // IX Grupa FCI — Psy do towarzystwa
  'Pudel Duży (Królewski)',
  'Pudel Średni',
  'Pudel Miniaturowy',
  'Pudel Toy',
  'Bichon Frise',
  'Maltańczyk',
  'Bolończyk',
  'Havanese',
  'Coton de Tulear',
  'Löwchen (Petit Chien Lion)',
  'Lhasa Apso',
  'Shih Tzu',
  'Chihuahua Krótkowłosy',
  'Chihuahua Długowłosy',
  'Papillon',
  'Phalène',
  'Cavalier King Charles Spaniel',
  'King Charles Spaniel',
  'Pekińczyk',
  'Chin Japoński',
  'Buldog Francuski',
  'Mops',
  'Gryfonik Brukselski',
  'Gryfonik Belgijski',
  'Petit Brabançon',
  'Kromfohrländer',
  'Rosyjski Toy (Russkiy Toy)',
  'Prazsky Krysarik',

  // X Grupa FCI — Charty
  'Whippet',
  'Greyhound',
  'Chart Afgański',
  'Saluki',
  'Borzoj (Chart Rosyjski)',
  'Chart Polski',
  'Deerhound (Chart Szkocki)',
  'Irish Wolfhound (Wilczarz Irlandzki)',
  'Galgo Español',
  'Azawakh',
  'Sloughi',
  'Chart Włoski (Piccolo Levriero Italiano)',
  'Magyar Agár',

  // Popularne mieszanki i rasy designerskie
  'Labradoodle',
  'Goldendoodle',
  'Cockapoo',
  'Cavapoo',
  'Maltipoo',
  'Pomsky',
  'Bernedoodle',
  'Aussiedoodle',
  'Schnoodle',
  'Yorkipoo',
  'Shih-Poo',
  'Puggle',

  // Opcja wpisania własnej
  'Inna rasa',
];

// ─── RASY KOTÓW ───
export const CAT_BREEDS = [
  'Kot Perski',
  'Maine Coon',
  'Ragdoll',
  'Brytyjski Krótkowłosy',
  'Brytyjski Długowłosy',
  'Sfinks (Sphynx)',
  'Bengalski',
  'Syberyjski',
  'Abisyński',
  'Birmański Święty',
  'Syjamski',
  'Orientalny',
  'Devon Rex',
  'Cornish Rex',
  'Norweski Leśny',
  'Szkocki Zwisłouchy (Scottish Fold)',
  'Scottish Straight',
  'Rosyjski Niebieski',
  'Savannah',
  'Somali',
  'Balijski',
  'Burmański',
  'Tonkijski',
  'Egzotyczny Krótkowłosy',
  'Ocicat',
  'Singapura',
  'Chartreux',
  'Ragamuffin',
  'Selkirk Rex',
  'Korat',
  'Europejski Krótkowłosy',
  'Turecki Van',
  'Turecki Angora',
  'Manx',
  'Kot Domowy (Mieszaniec)',
  'Inna rasa',
];

// Eksport domyślny — użyj w komponentach
export default DOG_BREEDS;
